import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../AuthContext";

function Login() {
  const [form, setForm] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const loginUser = async (e) => {
    e.preventDefault();
    if (!form.email.trim() || !form.password.trim()) {
      alert("Please enter email and password.");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
        "https://prakruthi.vercel.app/api/admin/login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(form),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Invalid credentials");
      }

      localStorage.setItem("user", JSON.stringify(data));
      authContext.signin(data._id, () => navigate("/"));
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex h-screen items-center justify-center p-4">
      <div className="grid w-full max-w-4xl grid-cols-1 md:grid-cols-2 bg-white rounded-lg shadow-lg overflow-hidden">
        {/* Left Section - Image */}
        <div className="hidden md:flex items-center justify-center bg-white p-6">
          <img
            src={require("../assets/loginn.png")}
            alt="Login"
            className="max-w-xs"
          />
        </div>

        {/* Right Section - Login Form */}
        <div className="p-8 w-full">
          <div className="text-center">
            <img
              className="mx-auto h-12 w-auto"
              src={require("../assets/logo.png")}
              alt="Your Company"
            />
            <h2 className="mt-4 text-3xl font-semibold text-gray-800">
              Admin Login
            </h2>
          </div>

          <form className="mt-6 space-y-4" onSubmit={loginUser}>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Email Address
              </label>
              <input
                type="email"
                name="email"
                className="mt-1 w-full p-3 border border-gray-300 rounded-sm focus:ring-2 focus:ring-green-400 focus:border-green-400"
                placeholder="Enter your email"
                value={form.email}
                onChange={handleInputChange}
                required
                disabled={loading}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">
                Password
              </label>
              <input
                type="password"
                name="password"
                className="mt-1 w-full p-3 border border-gray-300 rounded-sm focus:ring-2 focus:ring-green-400 focus:border-green-400"
                placeholder="Enter your password"
                value={form.password}
                onChange={handleInputChange}
                required
                disabled={loading}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className={`w-full py-3 rounded-lg font-medium text-white transition ${
                loading ? "bg-green-300" : "bg-green-500 hover:bg-green-600"
              }`}
            >
              {loading ? "Logging in..." : "Login"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
